import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code - Safe implementation
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        // Initialize Meta Pixel after script loads
        ;
        (window as any).fbq('init', '1904779843432668');
        (window as any).fbq('track', 'PageView');
      }
      // Initialize fbq function before script loads
      ;
      (window as any).fbq = function () {
        ;
        ((window as any).fbq.q = (window as any).fbq.q || []).push(arguments);
      };
      (window as any)._fbq = (window as any).fbq;
      (window as any).fbq.push = (window as any).fbq;
      (window as any).fbq.loaded = true;
      (window as any).fbq.version = '2.0';
      (window as any).fbq.queue = [];
      // Append script to head
      document.head.appendChild(script);
    } else if ((window as any).fbq) {
      // If pixel already loaded, just track pageview
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen font-sans text-slate-900 bg-white" data-id="element-263">
      <Hero data-id="element-264" />
      <ProblemSection data-id="element-265" />
      <SolutionSection data-id="element-266" />
      <ProductSection data-id="element-267" />
      <BonusSection data-id="element-268" />
      <PricingSection data-id="element-269" />
      <TestimonialsSection data-id="element-270" />
      <FAQSection data-id="element-271" />

      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-272">
        <div className="container mx-auto px-4" data-id="element-273">
          <p className="mb-4" data-id="element-274">
            &copy; {new Date().getFullYear()} DERECHO 360. Todos los derechos
            reservados.
          </p>
          <p data-id="element-275">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-276" />

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-277">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1904779843432668&ev=PageView&noscript=1" alt="" data-id="element-278" />
      </noscript>
    </div>;
}